import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { HttpService } from 'src/app/https.service';

@Component({
  selector: 'app-resetpwd',
  templateUrl: './resetpwd.component.html',
  styleUrls: ['./resetpwd.component.css']
})
export class ResetpwdComponent implements OnInit {

  @Input('parentData') parentData: any;
  @Output() event = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder,
              private httpservice: HttpService,
              private router: Router) { }

  submitted = false;
  show_password = false
  show_confirmpassword = false
  myForm: any = FormGroup;
  msg: string = "Please reset your password!"
 

  ngOnInit() {
    this.myForm = this.formBuilder.group({password: ['', Validators.required],
                                         confirmPassword: ['', Validators.required]})
  
  }

  get f() { return this.myForm.controls; }

  onSubmit(){
    this.msg = ""
    this.submitted = true
    let form = this.myForm
    if(form.value['password'] != form.value['confirmPassword']){
      form.controls['confirmPassword'].setErrors({'mismatch': true})
    }
    if(this.myForm.invalid) { return; }
    let url = `/admin/password/change`
    let data = {
        old_password: this.parentData['enteredPwd'],
        new_password: form.value['password']
    };
    this.httpservice.sendRePostRequest(url, data).subscribe(
      (resp: any) => {
        if(!resp['error']){
           this.event.emit({"msg": "reset-success", "resp": resp['msg']})
        }
    })
  }

}
